import React from "react";
import styles from "./styles.module.scss";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";
import SpaceMemberCard from "app/components/SpaceMemberCard";
import SpaceMemberModel from "app/models/SpaceMemberModel";
import { useTranslation } from "react-i18next";

const DemoSpaceMembers = () => {
  const { t } = useTranslation();

  const { selectedDemoSpace } = useSelector(
    (state: RootState) => state.demoSpace,
    shallowEqual,
  );

  return (
    <div className={styles.container}>
      <label>{t("Members")}</label>
      <div className={styles.members_wrapper}>
        {selectedDemoSpace?.members.map((member: SpaceMemberModel) => (
          <div key={member.id} className={styles.grid}>
            <SpaceMemberCard member={member} hasMenu={false} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemoSpaceMembers;
